export default __webpack_public_path__ + "fe5a701044365d7ebe7b6bc97a8a8fe1.png";